export const INVALID_SUPC_TOOLTIP_MESSAGE = 'This item is not available at this Operating Site. Please replace with a comparable item.';

export const SELECTIVE_TRANSFER_PAGE = {
    SELECT_ASSETS: 0,
    SELECT_ACCOUNTS: 1,
    TRANSFER_SUMMARY: 2,
}

export const BREAD_CRUMB_TITLE = {
    [SELECTIVE_TRANSFER_PAGE.SELECT_ASSETS]: 'Select Assets',
    [SELECTIVE_TRANSFER_PAGE.SELECT_ACCOUNTS]: 'Select Accounts',
    [SELECTIVE_TRANSFER_PAGE.TRANSFER_SUMMARY]: 'Transfer Summary',
}

export const TAB_KEY = {
    RECIPE: 'recipe',
    BATCH_RECIPE: 'batchRecipe',
    CUSTOM_INGREDIENT: 'customIngredient',
    MENU: 'menu',
    DESIGN: 'design',
};

export const ASSET_TYPE = {
    RECIPE: TAB_KEY.RECIPE,
    CUSTOM_INGREDIENT: TAB_KEY.CUSTOM_INGREDIENT,
    MENU: TAB_KEY.MENU,
    DESIGN: TAB_KEY.DESIGN,
    RECIPE_CATEGORY: 'recipeCategory',
};

export const TYPE_TAB_MAP = {
    [ASSET_TYPE.RECIPE]: TAB_KEY.RECIPE,
    [ASSET_TYPE.CUSTOM_INGREDIENT]: TAB_KEY.CUSTOM_INGREDIENT,
    [ASSET_TYPE.MENU]: TAB_KEY.MENU,
    [ASSET_TYPE.DESIGN]: TAB_KEY.DESIGN,
    [ASSET_TYPE.RECIPE_CATEGORY]: TAB_KEY.RECIPE,
};

export const tabs = [
    { key: TAB_KEY.RECIPE, title: 'Recipes' },
    { key: TAB_KEY.BATCH_RECIPE, title: 'Batch Recipes' },
    { key: TAB_KEY.CUSTOM_INGREDIENT, title: 'Custom Ingredients' },
    { key: TAB_KEY.MENU, title: 'Menus' },
    { key: TAB_KEY.DESIGN, title: 'Designs' },
];

export const DEPENDENT_TABS = {
    [TAB_KEY.RECIPE]: [TAB_KEY.BATCH_RECIPE, TAB_KEY.CUSTOM_INGREDIENT],
    [TAB_KEY.BATCH_RECIPE]: [TAB_KEY.BATCH_RECIPE, TAB_KEY.CUSTOM_INGREDIENT],
    [TAB_KEY.CUSTOM_INGREDIENT]: [],
    [TAB_KEY.MENU]: [TAB_KEY.RECIPE],
    [TAB_KEY.DESIGN]: [TAB_KEY.MENU],
}

export const recipeColumns = [
    { header: 'Recipe Name', key: 'recipeName', maxWidth: 250 },
    { header: 'Recipe Price per Serving', key: 'price', maxWidth: 110 },
    { header: 'Ingredient Cost per Serving', key: 'costPerServing', maxWidth: 120 },
    { header: 'Profit per Serving', key: 'profit', maxWidth: 80 },
];

export const batchRecipeColumns = [
    { header: 'Batch Recipe Name', key: 'recipeName', maxWidth: 250 },
    { header: 'Total Cost', key: 'costPerServing', maxWidth: 110 },
    { header: 'Cost per Unit', key: 'costPerPortion', maxWidth: 120 },
    { header: 'Yield', key: 'yield', maxWidth: 80 },
];

export const customIngredientColumns = [
    { header: 'Custom Ingredient Name', key: 'ingredientName', maxWidth: 250 },
    { header: 'Brand', key: 'ingredientBrand', maxWidth: 110 },
    { header: 'Cost per Unit', key: 'costPerUnit', maxWidth: 120 },
];

export const menuColumns = [
    { header: 'Menu Name', key: 'title', maxWidth: 250 },
    { header: 'Items', key: 'menuItemCount', maxWidth: 110 },
    { header: 'Costs Added', key: 'cost', maxWidth: 120 },
];

export const designColumns = [
    { header: 'Design Name', key: 'title', maxWidth: 240 },
    { header: 'Design Type', key: 'designTypeName', maxWidth: 100 },
    { header: 'Design Size', key: 'designSize', maxWidth: 100 },
    { header: 'Last Modified', key: 'updated', maxWidth: 120 },
];

export const defaultRecipeCategory = { label: "All Categories", value: -1 }

export const defaultDesignTypeCategory = { label: "All Design Types", value: -1 }

export const defaultDesignSizeCategory = { label: "All Design Sizes", value: -2 }

export const defaultOpco = { label: "All Sites", value: -1 }

export const TAB_KEY_TO_RESOURCE = {
    [TAB_KEY.RECIPE]: 'recipe',
    [TAB_KEY.BATCH_RECIPE]: 'recipe',
    [TAB_KEY.CUSTOM_INGREDIENT]: 'ingredient',
    [TAB_KEY.MENU]: 'menu',
    [TAB_KEY.DESIGN]: 'design',
}

export const MASTER_TABLE_NAME = 'master-data';
export const SELECTED_TABLE_NAME = 'selected-data';

export const displayDateFormat = 'YYYY-MM-DD HH:mm';

export const transferTypeMap = {
    copy: 'Copy and Share Assets',
}
export const assetTypes = [{ label: transferTypeMap.copy, value: 'copy' }];

export const ACCOUNT_REGEX = /^\d{3}-\d+$/;
